import { useFeatureFlag } from '@/hooks';
import { DynamicPointSize } from '../DynamicPointSize';
import * as state from '@/state';
import { useAtomValue } from 'jotai';
import { PointSizeSlider } from '../PointSizeSlider';

export const PointSizeControls = () => {
  const isBetaUser = useFeatureFlag('beta-user');

  const enableDynamicPointSize = useAtomValue<boolean>(state.enableDynamicPointSize);

  return (
    <>
      {isBetaUser && <DynamicPointSize />}

      {!enableDynamicPointSize && (
        <PointSizeSlider title="Point size" step={0.5} min={0} max={10} />
      )}
    </>
  );
};
